import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const getLatLang = async (address) => {
    const {app: appConfig} = getConfig()
    const apiKey = appConfig.googleAPI.googelAPIKey
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${apiKey}`
    let latLong = {success: false, lat: '', long: ''}

    try {
        const response = await fetch(url)
        const data = await response.json()
        if (data.status === 'OK') {
            const {lat, lng} = data.results[0].geometry.location
            latLong = {success: true, lat: lat, long: lng}
        } else {
            console.log('Geocoding error:', data.status)
        }
    } catch (error) {
        console.log('Fetch error:', error)
    }

    return latLong
}

export default getLatLang
